import React from 'react'
import { useTranslation } from 'lib/i18n'

import CtaButton from 'components/CtaButton/CtaButton'
import Link from 'components/Link/Link'
import usePath from 'hooks/usePath'
import useRouter from 'hooks/useRouter'

interface MoreButtonProps {
  setShowInfiniteScroll: (flag: boolean) => void
  loadMore: () => void
  loading: boolean
}

const MoreButton = (props: MoreButtonProps): JSX.Element => {
  const { setShowInfiniteScroll, loadMore, loading } = props

  const { t } = useTranslation()
  const router = useRouter()
  const path = usePath()
  const { page } = router.query
  const pageNumber = page ? Number(page) + 1 : 2

  return (
    <div style={{ textAlign: 'center', marginTop: 20 }}>
      <Link
        href={{
          pathname: path.nakedPath,
          query: { page: pageNumber },
        }}
      >
        <a
          onClick={(e) => {
            e.preventDefault()
          }}
          role="link"
          tabIndex={0}
        >
          <CtaButton
            onClick={() => {
              setShowInfiniteScroll(true)
              loadMore()
            }}
            loading={loading}
            data-cy="loadMoreButton"
          >
            {t('StartPageProfileProductList.loadMore', 'Load more')}
          </CtaButton>
        </a>
      </Link>
    </div>
  )
}

export default MoreButton
